export default __webpack_public_path__ + "static/media/6103.7ab712b7.svg";